module.exports = __webpack_public_path__ + "fonts/ralewayextrabolditalic.1f01e99.woff";